import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {Router} from '@angular/router';
import {Ordered} from 'src/app/models/ordered';
import {AuthService} from 'src/app/services/auth.service';
import {CaexService} from 'src/app/services/caex.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-caex-product',
  templateUrl: './caex-product.component.html',
  styleUrls: ['./caex-product.component.scss']
})
export class CaexProductComponent implements OnInit {

  public spinner: boolean;

  public matcher = new FormErrorStateMatcher();
  
  public orderForm: FormGroup;
  
  public current_price: any = {};
  public requirementPass: boolean;

  public arrayHandsOnTopics: any[] = []

  public handsOnTopicSelected: any = {}

  public value_balance: number = 0;
  public value_subscription: number = 0;
  public value_defaulting: number = 0;

  public value_total: number = 0;
  public op1_value_total: number = 0;
  public op2_value_total: number = 0;

  public value_total_us: number = 0;
  public op1_value_total_us: number = 0;
  public op2_value_total_us: number = 0;

  constructor (
    public _authService: AuthService,
    public _caexService: CaexService,
    private router: Router,
    private _formBuilder: FormBuilder,
  ) {

    if (!this._caexService.currentMember || !this._caexService.currentProduct) {
      this.router.navigate([ 'caex' ]);
    }

    this.orderForm = this.createForm()
  }

  ngOnInit () {
  }

  calculatFinalValue () {

    const dolarCotation = Number(this._caexService.dolarCotation)

    if (this._caexService.currentMember.situation == "1") {

      this.value_balance = Number(this._caexService.currentMember.balance)
      this.value_defaulting = Number(this.current_price.value_defaulting)
      this.value_subscription = Number(this.current_price.value)

      this.op1_value_total = this.value_balance + this.value_subscription
      this.op1_value_total_us = this.op1_value_total / dolarCotation

      this.op2_value_total = this.current_price.value_defaulting
      this.op2_value_total_us = this.op2_value_total / dolarCotation

    } else {

      this.value_subscription = this.current_price.value
      this.value_total = this.current_price.value
      this.value_total_us = this.value_total / dolarCotation
    }

  }

  getOption () {

    if(this.orderForm.valid){
      let value = this.orderForm.controls.value.value
  
      let order = this._caexService.createOrder(
        false,  //payAsOverdue
        0,      //balance
        value,  //subscription
        value,  //total
        'caex'  //origin
        )

      this.gotoConfirmation(order, false)
    }

  }

  createForm(){
    return this._formBuilder.group({
      value: new FormControl('', [ Validators.required ])
    });
  }

  gotoConfirmation (ordered: Ordered, updateMemberSituation: boolean) {
    
    this._caexService.currentOrdered = ordered
    this._caexService.updateMemberSituation = updateMemberSituation

    this.router.navigate([ 'caex-payment' ]);
  }

  goBack () {
    this.router.navigate([ 'caex-orders' ]);
    const value = this.op2_value_total
  }

}
